import { render, staticRenderFns } from "./IdeasoftChannels.vue?vue&type=template&id=1ffefff3&scoped=true"
import script from "./IdeasoftChannels.vue?vue&type=script&lang=js"
export * from "./IdeasoftChannels.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftChannels.vue?vue&type=style&index=0&id=1ffefff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffefff3",
  null
  
)

export default component.exports